/* eslint react/jsx-props-no-spreading: 0 */
import PropTypes from 'prop-types';

import Input from './Input';
import Select from './Select';
import CheckboxGroup from './CheckboxGroup';

const FormikControl = (props) => {
  const { control, ...rest } = props;
  switch (control) {
    case 'input':
      return <Input {...rest} />;
    case 'select':
      return <Select {...rest} />;
    case 'checkbox':
      return <CheckboxGroup {...rest} />;
    default:
      return null;
  }
};

FormikControl.propTypes = {
  control: PropTypes.string.isRequired,
};

export default FormikControl;
